export enum EBetGames {
    /// <summary>
    /// Standardní hra na 3 výsledky 1X2
    /// </summary>
    Standard1X2 = "0",

    /// <summary>
    /// Hendikepová sázka
    /// </summary>
    Handicap = "1",

    /// <summary>
    /// Na přesný výsledek zápasu
    /// </summary>
    CorrectScoreSoccer = "2",

    /// <summary>
    /// Na přesný výsledek zápasu v hokeji
    /// </summary>
    CorrectScoreHockey = "3",

    /// <summary>
    /// Průběh zápasu fotbal
    /// </summary>
    MatchProgressSoccer = "4",

    /// <summary>
    /// Průběh zápasu hokej
    /// </summary>
    MatchProgressHockey = "5",

    /// <summary>
    /// Na výsledek jen prvního poločasu
    /// </summary>
    FirstPartResultSoccer = "6",

    /// <summary>
    /// Na výsledek jen druhého poločasu
    /// </summary>
    SecondPartResultSoccer = "7",

    /// <summary>
    /// Na výsledek jen první třetiny
    /// </summary>
    FirstPartResultHockey = "8",

    /// <summary>
    /// Na výsledek jen druhé třetiny
    /// </summary>
    SecondPartResultHockey = "9",

    /// <summary>
    /// Na výsledek jen třetí třetiny
    /// </summary>
    ThirdPartResultHockey = "10",

    /// <summary>
    /// Pár / nepár - součet bodů, gólu v zápase bude sudý / lichý
    /// </summary>
    PairNotPair = "13",

    /// <summary>
    /// První gól dají domácí (1), hosté (2), nebude gól (NG)
    /// </summary>
    FirstGoal = "14",

    /// <summary>
    /// Postup / vítěz
    /// </summary>
    Winner = "15",

    /// <summary>
    /// První branka minuta (1-15, 16-30, 31-45, 46-60, 61-75, 75+, nebude gól)
    /// </summary>
    FirstGoalSoccerMinute = "16",

    /// <summary>
    /// První roh (dle 1G)
    /// </summary>
    FirstCorner = "17",

    /// <summary>
    /// První žlutá karta (dle 1G)
    /// </summary>
    FirstYellowCard = "18" /* **************** */,

    /// <summary>
    /// První červená karta (dle 1G)
    /// </summary>
    FirstRedCard = "19" /* **************** */,

    /// <summary>
    /// Standardní hra na 2 výsledky 12
    /// </summary>
    Standard12 = "20",

    /// <summary>
    /// Přesný výsledek v tenise
    /// </summary>
    CorrectScoreTennis = "21",

    /// <summary>
    /// Na výsledek první sady
    /// </summary>
    FirstPartResultTennis = "56" /* **************** */,

    /// <summary>
    /// Na výsledek druhé sady
    /// </summary>
    SecondPartResultTennis = "57" /* **************** */,

    /// <summary>
    /// Na výsledek třetí sady
    /// </summary>
    ThirdPartResultTennis = "58" /* **************** */,

    /// <summary>
    /// Na výsledek čtvrté sady
    /// </summary>
    FourthPartResultTennis = "59" /* **************** */,

    /// <summary>
    /// Na výsledek páté sady
    /// </summary>
    FifthPartResultTennis = "60" /* **************** */,

    /// <summary>
    /// Hra na umístění v tabulce
    /// </summary>
    OutRightTotal = "30",

    /// <summary>
    /// Domácí vstřelí branku (např. Německo vstřelí branku)
    /// </summary>
    HomeTeamShootsGoal = "33",

    /// <summary>
    /// Hosté vstřelí branku
    /// </summary>
    AwayTeamShootsGoal = "34",

    /// <summary>
    /// Hra na umístění v zápase, při remíze dochází k vyhodnocení kurzem 1,00
    /// </summary>
    OutRightStandard = "35",

    /// <summary>
    /// Počet gólů (branek) POD/NAD
    /// </summary>
    NumberOfGoalsUnderOver = "36",

    /// <summary>
    /// Počet bodů POD/NAD
    /// </summary>
    NumberOfPointsUnderOver = "37",

    /// <summary>
    /// Počet žlutých karet (dle G) POD/NAD
    /// </summary>
    YellowCardCountUnderOver = "38",

    /// <summary>
    /// Počet červených karet (dle G) POD/NAD
    /// </summary>
    RedCardCountUnderOver = "39",
    /// <summary>
    /// Hendikepová sázka na 2 výsledky 12
    /// </summary>
    Spread = "40",
    /// <summary>
    /// Další gól dájí domácí/hosté - standartní hra 1X2
    /// </summary>
    NextGoal = "41",
    /// <summary>
    /// 1X2
    /// </summary>
    WinnerOT = "42",
    /// <summary>
    /// standart 1X2 od current score
    /// </summary>
    WinnerRestOfMatch = "43",
    /// <summary>
    /// odds fields 1X2
    /// </summary>
    WinnerGameXYsetN = "44",
    /// <summary>
    /// odds fields 1X2
    /// </summary>
    NextGoalOT = "45",
    /// <summary>
    /// odds field 1 2
    /// </summary>
    NextGoalPenaltyShootout = "46",
    /// <summary>
    /// odds field 1 2
    /// </summary>
    FirstKickOff = "47" /* **************** */,
    /// <summary>
    /// standart 1 2
    /// </summary>
    WinnerTeamPenaltyShootout = "48",
    /// <summary>
    /// Nad / pod
    /// </summary>
    NumberOfGoalsOverTime = "49",
    /// <summary>
    /// odds fields: 2:0 2:1 0:2 1:2
    /// </summary>
    CorrectScoreTwoSetGameTennis = "50",
    /// <summary>
    /// odds fields: 3:0 3:1 3:2 0:3 1:3 2:3
    /// </summary>
    CorrectScoreThreeSetGameTennis = "51",
    /// <summary>
    /// Neznamy GameTyp
    /// </summary>
    Unknown = "99"
}
